import React from "react"
import types from "prop-types"
import { useDispatch } from "react-redux"
import { deleteFormQuestionOption } from "reduxSlices/formBuilderSlice"
import { XIcon } from "shared/icons"

const OptionDeleteButton = ({
  sectionIndex, questionIndex, optionIndex, buttonLabel,
}) => {
  const dispatch = useDispatch()

  const deleteOption = (event) => {
    event.preventDefault()
    dispatch(deleteFormQuestionOption({ sectionIndex, questionIndex, optionIndex }))
  }

  return (
    <button onClick={deleteOption} aria-label={buttonLabel}>
      <XIcon
        className="ml-1"
        ariaHidden
      />
    </button>
  )
}

OptionDeleteButton.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
  optionIndex: types.number.isRequired,
  buttonLabel: types.string.isRequired,
}

export default OptionDeleteButton
